<template>
  <div v-click-outside="close" id="form-card" class="form-card form-read-more">
    <img :src="card">
    <div class="login-card">
      <template>
        <v-stepper :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'" v-model="e1">
          <v-stepper-items>
            <v-stepper-content step="1">
              <div :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en','login-header']">{{title}}</div>
              <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','login-desc']">{{desc}}</div>
              <div class="login-content">
                <input id="num" @input="valid" v-model="phoneNum" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','number-field px-2']" :placeholder="this.$lang === 'ar' ? 'رقم الجوال' : 'Mobile Number'" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');" :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'">
                <div autofocus v-if="!validNum && clicked" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
              </div>
              <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','login-footer']">{{ this.$store.state.addNewNumber ? '' : footer }}<span :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'px-2']" @click="action">{{ this.$store.state.addNewNumber ? '' : footerAction }}</span></div>
              <div class="stepper-btn-container d-flex justify-content-center">
                <div class="btn-container" @click="e1 = 1">
                  <div :class="[e1 === 1 ? 'active-step' : '','stepper-btn']"></div>
                </div>
                <div class="btn-container" @click="secondStepHandle">
                  <div :class="[e1 === 2 ? 'active-step' : '','stepper-btn']"></div>
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <div :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en','login-header']">{{$t('register.verify')}}</div>
              <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','login-desc']">{{$t('register.verifyDesc')}} {{ phoneNum }}</div>
              <div class="verify-content" dir="ltr">
                <input id="first" v-model="first"  class="verify-field" type="text" maxlength="1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" @keyup="clickEvent('first', 'second')" autofocus >
                <input id="second" v-model="second"  class="verify-field" type="text" maxlength="1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" @keyup="clickEvent('second', 'third')" >
                <input id="third" v-model="third" class="verify-field" type="text" maxlength="1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" @keyup="clickEvent('third', 'fourth')" >
                <input id="fourth" v-model="fourth"  class="verify-field" type="text" maxlength="1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" @keyup="clickEvent('fourth', 'fifth')" >
                <input id="fifth" v-model="fifth"  class="verify-field" type="text" maxlength="1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" @keyup="clickEvent('fifth', 'sixth')" >
                <input id="sixth" v-model="sixth"  class="verify-field" type="text" maxlength="1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" @keyup="clickEvent('sixth', 'sixth')"  dir="ltr">
              </div>
              <div style="user-select: none" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','verify-footer']">{{$t('register.code')}}
                <span :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'" @click="codeResend">
                  <span style="text-decoration: underline; cursor: pointer" :style="counter !== 120 && { opacity: 0.5, cursor: 'not-allowed' }">{{$t('register.resend')}}</span>
                  <span v-if="counter !== 120" style="color: #E50019; font-size: 9px; text-decoration: none !important; user-select: none"> {{ counter }} {{this.$lang === 'ar' ? 'ثانية' : 'sec'}}</span>
                </span>
              </div>
              <div class="stepper-btn-container d-flex justify-content-center">
                <div class="btn-container" @click="e1 = 1">
                  <div :class="[e1 === 1 ? 'active-step' : '','stepper-btn']"></div>
                </div>
                <div class="btn-container" @click="e1 = 2">
                  <div :class="[e1 === 2 ? 'active-step' : '','stepper-btn']"></div>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </div>
    <div :class="[this.$lang === 'ar' ? 'black-blur-right' : 'black-blur-left' , 'black-blur']"></div>
    <div @click="handleSubmit" :class="[this.$lang === 'ar' ? 'yellow-button-right' : 'yellow-button-left', 'yellow-button flex-center']">
      <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
      <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
<!--      <img v-if="!isLoading" class="inner_arrow" src="../../assets/icons/buttonArrow.svg">-->
      <span v-if="!isLoading && e1 === 1" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']">{{$t('next')}}</span>
      <span v-if="!isLoading && e1 === 2" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']">{{$t('submit')}}</span>
    </div>
    <div :class="[this.$lang === 'ar' ? 'blur-outer-button-right' : 'blur-outer-button-left' ,'blur-outer-button']">
    </div>
  </div>
</template>
<script>
import pcCard from '../../assets/images/form-card-shadow.svg'
import mobileCard from '../../assets/images/outer-card-form.svg'
import $ from 'jquery'
import LoginRepository from '../../repositories/loginRepository'
import SignInRepository from '../../repositories/SignInRepository'
import SignupRepository from '../../repositories/SignupRepository'
import CodeResendRepository from '../../repositories/CodeResendRepository'
import ms from '../../utils/messeging.js'
import { JSEncrypt } from 'jsencrypt'
import publicKey from '../../assets/public.txt'
import { mapState, mapActions } from 'vuex'
import AddNumVerifyRepository from '../../repositories/AddNumVerifyRepository'
import AddNewItemRepository from '../../repositories/AddNewItemRepository'
export default {
  data () {
    return {
      addNumRepo: new AddNewItemRepository(),
      verifyNewNumRepo: new AddNumVerifyRepository(),
      signupRepo: new SignupRepository(),
      signingRepo: new SignInRepository(),
      loginRepo: new LoginRepository(),
      codeRepo: new CodeResendRepository(),
      card: pcCard,
      title: this.$store.state.addNewNumber ? this.$t('addNum.title') : this.$store.state.registerDialog ? this.$t('register.title') : this.$t('login.title'),
      desc: this.$store.state.addNewNumber ? this.$t('addNum.desc') : this.$store.state.registerDialog ? this.$t('register.desc') : this.$t('login.desc'),
      footer: this.$store.state.registerDialog ? this.$t('register.footer') : this.$t('login.register'),
      footerAction: this.$store.state.registerDialog ? this.$t('register.footerLog') : this.$t('login.registerBtn'),
      e1: 1,
      phoneNum: '',
      loginNum: '',
      clicked: false,
      validNum: false,
      validLoginNum: false,
      typedBefore: false,
      verificationCode: '',
      isLoading: false,
      disabled: false,
      stepOneHandled: false,
      publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhEX/zbJGcaWAwXsKTAxS
08X+FU2OP636wA98ZzTqceEA5bQA6UdGP55k3fDEhrBjCZ7zk5Mbwzh7XeOsmjq3
bAI+1qd3/US7RVHMmZzTs/B2SRwAdrk34bRBHGkCUdh8K3BvI74NrzTJXIikKiTA
Zelay7JqKV3HChKCcDrnFX9j4SnYrFFH6xCLMWkewSheQEGRjtV308PaKUNmrFDT
XMlzEsnX0UwOpztFA3ZLaashuzFUIlOs4HjFWYcZtMKSa8Ykx9GOdpiWCVN3+7bn
6QVHMv7yUWWL0/hNMbj14JHeSLyPA+aVK1j/NAa0ujyJQvL5D8Vz226SrpP8VOe0
1wIDAQAB
-----END PUBLIC KEY-----`,
      first: '',
      second: '',
      third: '',
      fourth: '',
      fifth: '',
      sixth: '',
      counter: 120,
      isResend: true,
      timeInterval: null
    }
  },
  computed: {
    ...mapState({
      logedIn: state => state.user.token !== null
    })
  },
  created () {
    if (this.$store.state.window <= 535) {
      this.card = mobileCard
    }
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      if (val <= 536) {
        this.card = mobileCard
      } else {
        this.card = pcCard
      }
    })
  },
  mounted () {
    setTimeout(() => {
      if (this.$lang === 'ar') {
        $('.form-card img').css('transform', 'rotateY(180deg)')
      }
    })
  },
  watch: {
    counter (val) {
      this.clear(val)
    }
  },
  methods: {
    ...mapActions('user', ['doLogin']),
    clear (val) {
      if (val === 0) {
        clearInterval(this.timeInterval)
        this.isResend = true
        this.counter = 120
      }
    },
    prevent () {
      if (!this.isResend) {
        return
      }
      this.isResend = false
      this.timeInterval = setInterval(() => {
        this.counter--
      }, 1000)
    },
    clearCode () {
      this.first = ''
      this.second = ''
      this.third = ''
      this.fourth = ''
      this.fifth = ''
      this.sixth = ''
      this.verificationCode = ''
    },
    async codeResend () {
      if (!this.isResend) {
        return
      }
      try {
        const formData = new FormData()
        formData.append('gsm', this.phoneNum)
        this.prevent()
        const response = await this.codeRepo.post(formData)
        if (response.data.status === 200) {
          // this.isResend = true
          // this.counter = 120
          // clearInterval(this.timeInterval)
          this.clearCode()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
    },
    action () {
      if (this.$store.state.registerDialog) {
        this.$store.state.registerDialog = false
        this.$store.state.loginDialog = true
        $('.v-overlay.theme--dark').css('display', 'none')
      } else if (this.$store.state.loginDialog) {
        this.$store.state.loginDialog = false
        this.$store.state.registerDialog = true
        $('.v-overlay.theme--dark').css('display', 'none')
      }
    },
    secondStepHandle () {
      this.clicked = true
      const regex = /^[0][9][4567][0-9]{7}$/
      const result = regex.test(this.phoneNum)
      if (result) {
        // this.e1 = 2
        if (!this.stepOneHandled) {
          if (this.$store.state.registerDialog) {
            this.signupHandle()
          } else {
            this.loginHandle()
          }
        } else {
          this.e1 = 2
        }
      }
    },
    valid () {
      const regex = /^0[0-9]{9}$/
      const result = regex.test(this.phoneNum)
      if (this.clicked) {
        if (result) {
          // this.e1 = 2
          this.validNum = true
          if (this.$store.state.registerDialog) {
            // this.signupHandle()
          } else {
            // this.loginHandle()
          }
        } else {
          this.validNum = false
        }
      } else {
        if (result) {
          if (this.$store.state.registerDialog) {
            // this.signupHandle()
          } else {
            // this.loginHandle()
          }
          this.clicked = true
          this.validNum = true
          // this.e1 = 2
        }
      }
    },
    async signupHandle () {
      if (this.isLoading) {
        return
      }
      const formData = new FormData()
      this.isLoading = true
      const obj = this.$store.state.addNewNumber ? this.addNumRepo : this.signupRepo
      try {
        formData.append('gsm', this.phoneNum)
        const response = await obj.post(formData)
        if (response.data.status === 200) {
          this.e1 = 2
          this.stepOneHandled = true
          this.prevent()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      document.activeElement.blur()
      setTimeout(() => {
        document.getElementById('first').focus()
      })
      this.isLoading = false
    },
    clickEvent (first, last) {
      const regex = /^[0-9]$/
      if (document.getElementById(first).value.length && regex.test(document.getElementById(first).value)) {
        document.getElementById(last).focus()
      }
      // this.verificationCode += document.getElementById(first).value
      this.verificationCode = this.first + this.second + this.third + this.fourth + this.fifth + this.sixth
    },
    close () {
      this.$store.state.addNewNumber = false
      this.$store.state.loginDialog = false
      this.$store.state.registerDialog = false
      this.$store.state.submitted = false
    },
    handleSubmit () {
      this.$store.state.submitted = true
      // const regex = /^[0][9][4567][0-9]{7}$/
      // const result = regex.test(this.phoneNum)
      if (this.$store.state.loginDialog) {
        this.codeAndNumberHandle()
      } else if (this.$store.state.registerDialog) {
        this.codeAndNumberHandle()
      }
    },
    async loginHandle () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const formData = new FormData()
      formData.append('gsm', this.phoneNum)
      try {
        const response = await this.loginRepo.post(formData)
        if (response.data.status === 200) {
          this.e1 = 2
          this.stepOneHandled = true
          this.prevent()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        // this.isLoading = false
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch (e) {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.isLoading = false
      document.activeElement.blur()
      setTimeout(() => {
        document.getElementById('first').focus()
      })
    },
    async codeAndNumberHandle () {
      // console.log('clicked', this.verificationCode)
      if (this.e1 === 1) {
        this.secondStepHandle()
        return
      }
      if (this.disabled) {
        return
      }
      if (this.verificationCode.length === 6) {
        const obj = this.$store.state.addNewNumber ? this.verifyNewNumRepo : this.signingRepo
        this.disabled = true
        const crypt = new JSEncrypt()
        crypt.setPublicKey(publicKey)
        const message = `${this.phoneNum}#${this.verificationCode}`
        const encrypt = crypt.encrypt(message)
        const formData = new FormData()
        formData.append('data', encrypt)
        this.isLoading = true
        try {
          const response = await obj.post(formData)
          if (response.data.status) {
            this.doLogin(response.data.data)
            // localStorage.setItem('token', response.data.data.token)
            // this.$store.dispatch('setToken')
            ms.successMessage(response.data.message)
            this.$store.state.isAdded++
            this.close()
          } else {
            this.loading = false
            ms.errorMessage(response.data.message)
          }
        } catch (e) {
          try {
            if (e.response.data) {
              ms.errorMessage(e.response.data.message)
            }
          } catch {
            ms.errorMessage('Sorry Something Went Wrong')
          }
        }
      }
      this.isLoading = false
      this.disabled = false
    }
  }
}
</script>
<style>
.v-dialog.v-dialog--active{
  box-shadow: unset !important;
  margin: 0 ;
}
.v-dialog.dialog-bottom-transition-leave-active.dialog-bottom-transition-leave-to{
  box-shadow: none !important;
  outline: none !important;
}
.form-card{
  width: 650px;
  height: 450px;
  margin: 0 auto;
  position: relative;
}
.form-card img{
  width: 100%;
  height: 100%;
}
@media (max-width: 800px) {
  .form-card{
    width: 500px;
    height: 330px;
  }
}
@media screen and (max-width: 536px){
  .form-card{
    width: 395px;
    height: 415px;
  }
}
@media screen and (max-width: 400px){
  .form-card{
    width: 350px;
    height: 400px;
  }
}
</style>
<style lang="scss">
.form-read-more .read-more {
  display: inline-block!important;
  //animation: none!important;
}
#form-card {
  .yellow-button{
    width: 70px !important;
    height: 70px !important;
    bottom: 27px;
  }
  .blur-outer-button{
    width: 73px;
    height: 73px;
    bottom: 25.5px;
  }
  .black-blur{
    bottom: 23px;
  }
  .white-blur-left{
    left: -4px !important;
  }
  .white-blur-right{
    right: -4px !important;
  }
  .yellow-button-left{
    right: 87.5px !important;  /*128.5*/
  }
  .blur-outer-button-left{
    right: 86px !important; /*128.5*/
  }
  .black-blur-left{
    right: 84.5px !important;
  }
  .yellow-button-right{
    right: 493.5px !important;
  }
  .blur-outer-button-right{
    right: 492.8px !important;
  }
  .black-blur-right{
    right: 487.5px !important;
  }
  .outer-img-ar{
    transform: rotateY(180deg) !important;
  }
}
@media (max-width: 800px) {
  #form-card{
    .yellow-button{
      width: 60px !important;
      height: 60px !important;
      bottom: 20px !important;
    }
    .blur-outer-button{
      width: 63px;
      height: 63px;
      bottom: 19px !important;
    }
    .white-blur{
      top: -4px !important;
    }
    .black-blur{
      width: 40px;
      height: 40px;
      bottom: 22px;
    }
    .yellow-button-left{
      right: 71.5px !important;
    }
    .blur-outer-button-left{
      right: 70.5px !important;
    }
    .black-blur-left{
      right: 70.5px !important;
    }
    .yellow-button-right{
      right: 368.5px !important;
    }
    .blur-outer-button-right{
      right: 366.5px !important;
    }
    .black-blur-right{
      right: 386.5px !important;
    }
  }
}
@media (max-width: 536px) {
  #form-card{
    .yellow-button{
      width: 80px !important;
      height: 80px !important;
      bottom: 22px !important;
    }
    .blur-outer-button{
      width: 83px !important;
      height: 83px !important;
      bottom: 20px !important;
    }
    .white-blur{
      top: -4px !important;
    }
    .black-blur{
      bottom: 28px !important;
    }
    .yellow-button-left{
      right: 106px !important;
    }
    .blur-outer-button-left{
      right: 105.5px !important;
    }
    .black-blur-left{
      right: 102.5px !important;
    }
    .yellow-button-right{
      right: 209.5px !important;
    }
    .blur-outer-button-right{
      right: 208px !important;
    }
    .black-blur-right{
      right: 222.5px !important;
    }
  }
}
@media (max-width: 400px) {
  #form-card {
    .yellow-button{
      width: 72px !important;
      height: 72px !important;
      bottom: 23.5px !important;
    }
    .blur-outer-button{
      width: 75px !important;
      height: 75px !important;
      bottom: 21.5px !important;
    }
    .white-blur{
      top: -4px !important;
    }
    .black-blur{
      bottom: 22px;
    }
    .yellow-button-left{
      right: 89.5px !important;
    }
    .blur-outer-button-left{
      right: 88.5px !important;
    }
    .black-blur-left{
      right: 85.5px !important;
    }
    .yellow-button-right{
      right: 188.5px !important;
    }
    .blur-outer-button-right{
      right: 186.5px !important;
    }
    .black-blur-right{
      right: 206.5px !important;
    }
  }
}
</style>
<style lang="scss">
@import "src/assets/sass/main";
.validation{
  font-size: 11px;
  color: $--red !important;
  width: 80%;
  margin: 0 auto;
}
.v-stepper.v-stepper--is-booted.v-sheet.theme--light,
.v-stepper.v-sheet.theme--light{
  height: 100%;
  box-shadow: none !important;
  background: transparent !important;
}
.v-stepper__items,
.v-stepper__wrapper{
  height: 100%;
}
.v-stepper__header{
  display: none;
}
.v-stepper__content{
  padding: 0 !important;
}
button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default.primary,
button.v-btn.v-btn--text.theme--light.v-size--default{
  display: none;
}
.v-overlay.theme--dark{
  display: none !important;
}
.login-card {
  width: 500px;
  height: 320px;
  position: absolute;
  top: 25px;
  left: 77px;
}
.login-header{
  padding: 3.5rem 0 0 0;
  color: $--yellow;
  font-size: 20px;
}
.login-desc{
  font-size: 12px;
}
.login-content{
  padding-top: 3.5rem;
}
.verify-content{
  padding-top: 2.8rem;
}
.verify-footer{
  padding: 2.8rem 0 1.5rem 0;
}
.number-field{
  border: 2px solid $--yellow;
  width: 80%;
  line-height: 2.2;
  border-radius: 8px;
}
//.number-field:focus{
//  outline: none;
//}
.number-field::placeholder{
  color: #000;
  font-size: 12px;
}
.login-footer{
  padding: 3.5rem 0 20px 0;
  font-size: 12px;
  span {
    color: $--yellow !important;
    cursor: pointer;
  }
}
.verify-footer{
  font-size: 12px;
  span {
    color: $--yellow;
    //cursor: pointer;
  }
}
.btn-container{
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stepper-btn {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #bcbbbb;
  cursor: pointer;
}
.active-step{
  background: #383838 !important;
}
input.verify-field {
  width: 50px;
  height: 50px;
  border: 2px solid #FFCB05;
  border-radius: 9px;
  margin: 0 5px;
  text-align: center;
}
//.verify-field:focus{
//  outline: none;
//}
@media (max-width: 800px) {
  .login-card {
    width: 390px;
    height: 230px;
    left: 55px;
  }
  .login-header{
    padding: 25px 0 0 0;
  }
  .login-content{
    padding-top: 2rem;
  }
  .number-field{
    width: 85%;
  }
  .login-footer{
    padding: 30px 0 20px 0;
  }
  .verify-content{
    padding-top: 1.5rem;
  }
  .verify-footer{
    padding: 1.5rem 0 1.5rem 0;
  }
}
@media screen and (max-width: 536px){
  .login-card {
    width: 280px;
    height: 290px;
    left: 57px;
  }
  .login-header{
    padding: 35px 0 0 0;
    font-size: 16px;
  }
  .login-desc{
    font-size: 10px;
  }
  .login-content{
    padding: 3rem 15px 0 15px;
  }
  .number-field{
    width: 100%;
    line-height: 2.5;
  }
  .login-footer{
    padding-top: 4rem;
    font-size: 11px;
  }
  input.verify-field {
    margin: 0 3px;
    width: 38px;
    height: 38px;
    border-radius: 8px;
  }
  .verify-content{
    padding-top: 3.5rem;
  }
  .verify-footer{
    padding: 3.5rem 0 1.5rem 0;
  }
}
@media screen and (max-width: 400px){
  .login-content{
    padding: 3rem 0px 0 0px;
  }
  .login-card {
    width: 270px;
    height: 290px;
    left: 38px;
  }
  .login-header{
    padding: 20px 0 0 0;
    font-size: 20px;
  }
  .login-desc{
    font-size: 14px;
  }
  .login-content{
    padding-top: 2.5rem;
  }
  .number-field{
    width: 90%;
    line-height: 3;
  }
  .login-footer{
    padding-top: 2.5rem;
    font-size: 14px;
  }
}
</style>
